import currency from "currency.js";

const formats = {
  BRL: { symbol: "R$ ", decimal: ",", separator: "." },
};

export const formatCurrency = (value: number | string, formatType?: keyof typeof formats): string => {
  return currency(value, formats[formatType || "BRL"]).format();
};
